"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
const ScheduleEntryTypeCategory_1 = require("./ScheduleEntryTypeCategory");
const ScheduleEntryTypeIcon_1 = require("./ScheduleEntryTypeIcon");
function isScheduleEntryType(object) {
    return checkScheduleEntryType(object).fulfilled;
}
exports.isScheduleEntryType = isScheduleEntryType;
function checkScheduleEntryType(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("id"), __1.hasChoice("category", Object.values(ScheduleEntryTypeCategory_1.ScheduleEntryTypeCategory)), __1.hasString("name"), __1.hasChoice("icon", Object.values(ScheduleEntryTypeIcon_1.ScheduleEntryTypeIcon)), __1.hasString("colorTag"), __1.hasBoolean("isDefault").optional(), __1.hasBoolean("isDeleted").optional()).withOptions(options).explain();
}
exports.checkScheduleEntryType = checkScheduleEntryType;
//# sourceMappingURL=ScheduleEntryType.js.map